import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

// ---------- Styled Components ----------

const FooterContainer = styled.footer`
  position: relative;
  background: linear-gradient(135deg, #0d0d0d, #1a1a1a);
  color: #ddd;
  padding: 80px 20px 40px;
  overflow: hidden;
`;

const Wave = styled.div`
  position: absolute;
  top: -1px;
  left: 0;
  width: 100%;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const FooterWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 40px;
  position: relative;
  z-index: 2;
`;

const FooterSection = styled(motion.div)``;

const SectionTitle = styled.h3`
  font-size: 18px;
  margin-top: 50px;
  color: #ced4da;
`;

export const Link = styled.a`
  display: block;
  color: #6c757d;
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.3s;
  &:hover {
    color: #f8f9fa;
  }
`;

export const Text = styled.p`
  margin: 0 0 10px;
  line-height: 1.6;
  a {
    color: #005f73;
    text-decoration: none;
  }
`;

export const Disclaimer = styled.div`
  text-align: left;
  font-size: 14px;
  color: #777;
  position: relative;
  z-index: 2;
`;
export const Developer = styled.div`
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #777;
  position: relative;
  z-index: 2;
  a {
    color: #f8f9fa;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s;

    &:hover {
      color: #fdc500;
    }
  }
`;
export const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  .footer-socials {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  &.nav-socials a {
    color: black;
  }
  a {
    color: #ddd;
    font-size: 20px;
    transition:
      transform 0.3s,
      color 0.3s;

    &:hover {
      transform: scale(1.2);
    }
  }
`;

const MapContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #333;
  height: 200px;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

const FooterLinksContainer = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
`;

// ---------- Motion Variants ----------

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

// ---------- Component ----------

export default function Footer() {
  return (
    <FooterContainer>
      {/* Shape Divider */}
      <Wave>
        <svg viewBox="0 0 1440 320">
          <path
            fill="#0d0d0d"
            fillOpacity="1"
            d="M0,160L80,144C160,128,320,96,480,90.7C640,85,800,107,960,112C1120,117,1280,107,1360,101.3L1440,96L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
          ></path>
        </svg>
      </Wave>

      <FooterWrapper>
        {/* Brand/About */}
        <FooterSection
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <SectionTitle>Our Office</SectionTitle>
          <Text>
            Wealthies.in SBR Arcade, 1st Floor, Site No.39- 44, <br />
            Ramakrishnappa Layout, Jambu savari Dinne Road, Gottigere, <br />
            Bannerghatta Main Road, <br />
            Bangalore - 560083
          </Text>
          <Text>Monday – Friday</Text>
          <Text>10:00 AM – 5:30 PM</Text>
          <Text>
            <a href="tel:+918904499932">
              📞 <b>+918904499932</b>
            </a>
          </Text>
          <Text>
            ✉️{" "}
            <a href="mailto:contact@wealthies.in">
              <b> contact@wealthies.in </b>
            </a>
          </Text>
          {/* <SectionTitle>Working Hours</SectionTitle> */}

          <SocialIcons className="footer-socials">
            <Link href="https://www.facebook.com/people/Wealthiesin/61578543297980/">
              <FaFacebook />
            </Link>
            <Link href="/">
              <FaTwitter />
            </Link>
            <Link href="/">
              <FaLinkedin />
            </Link>
            <Link href="https://www.instagram.com/wealthies.in?igsh=MW1xODdoM2c1dWdtag%3D%3D">
              <FaInstagram />
            </Link>
          </SocialIcons>

          <MapContainer>
            <iframe
              title="Our Office Location"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3889.755117820179!2d77.58524707507453!3d12.859086987446046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDUxJzMyLjciTiA3N8KwMzUnMTYuMiJF!5e0!3m2!1sen!2sin!4v1756015491222!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </MapContainer>
        </FooterSection>
        <FooterLinksContainer>
          <FooterSection
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <SectionTitle>Insurance</SectionTitle>
            <Link href="/life-insurance">Life Insurance</Link>
            <Link href="/term-insurance">Term Insurance</Link>
            <Link href="/health-insurance">Health Insurance</Link>
            <Link href="/motor-insurance">Motor Insurance</Link>
          </FooterSection>

          <FooterSection
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <SectionTitle>Taxes</SectionTitle>
            <Link href="/income-tax">Income Tax</Link>
            <Link href="/gst">GST</Link>
            <Link href="/property-tax">Property Tax</Link>
            <Link href="/professional-tax">Professional Tax</Link>
          </FooterSection>

          <FooterSection
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <SectionTitle>Quick Links</SectionTitle>
            <Link href="/about-us">About Us</Link>
            <Link href="/contact-us">Contact Us</Link>
            <Link href="/our-team">Our Teams</Link>
            <Link href="/carrers">Careers</Link>
          </FooterSection>
          <FooterSection
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <SectionTitle>Legal</SectionTitle>
            <Link href="/terms-and-conditions">Terms and Conditions</Link>
            <Link href="/privacy-policy">Privacy Policy</Link>{" "}
            <Link href="/refund-policy">Refund Policy</Link>
            <Link href="/disclaimer">Disclaimer</Link>
          </FooterSection>

          <FooterSection
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <SectionTitle>Company Info</SectionTitle>
            <Link>Company Name : Shreeman Assure Services Pvt Ltd. </Link>
            <Link>Brand name : Wealthies.in</Link>
            <Link>CIN Number : U70200KA2025PTC206719 </Link>
            <Link>GST Number : 29ABRCS0048R1ZE </Link>
          </FooterSection>

          {/* <FooterSection
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
         
          </FooterSection> */}
        </FooterLinksContainer>
      </FooterWrapper>
      <p style={{ padding: "40px 0px" }}>
        <Disclaimer>
          Disclaimer: Wealthies.in is a brand name of Shreeman Assure Services
          Pvt. Ltd CIN : U70200KA2025PTC206719. We are dedicated to providing
          free and unbiased financial education to help individuals make
          informed decisions. We do not sell or promote any financial products,
          nor do we endorse any specific brands or services. All information
          provided is purely for educational purposes.
        </Disclaimer>{" "}
      </p>
      <Developer> © 2025 Wealthies.in</Developer>

      <Developer>
        Developed by{" "}
        <a
          href="https://www.instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vijay M D
        </a>
      </Developer>
    </FooterContainer>
  );
}
